import http from "../http/http-config";
import { FamilyCombinedQuotationResponse } from "../models/FamilyCombinedQuotationResponse";
export default new class FamilyCombinedService {
    async createFamilyCombined927Quotation(model: string): Promise<FamilyCombinedQuotationResponse> {
        const response = await http.post<FamilyCombinedQuotationResponse>("FamilyCombinedQuotation", model);
        if (response.status === 204) {
            throw new Error(response.status.toString());
        }
        return response.data;
    }

    async setSessionFamilyCombinedPremiumQuotationPlan(
        model: FamilyCombinedQuotationResponse
    ): Promise<void> {
        const response = await http.post(
            "FamilyCombinedQuotation/SetSessionFamilyCombinedPremiumQuotationPlan",
            model
        );

        if (response.status === 204) {
            throw new Error(response.status.toString());
        }
    }
}